/**************************************************
 * Nombre:       Formulario_Mixlrs
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid} from "@mui/material";
import IngresoTexto from "../../Modulo_formularios/Componentes/IngresoTexto";
import {GroupOutlined, Link, TitleOutlined} from "@mui/icons-material";
import IngresoImagenCrop from "../../Modulo_formularios/Componentes/IngresoImagenCrop";
import IngresoFecha from "../../Modulo_formularios/Componentes/IngresoFecha";
import IngresoHora from "../../Modulo_formularios/Componentes/IngresoHora";
import IngresoHoraSelect from "../../Modulo_formularios/Componentes/IngresoHoraSelect";

const Formulario_Mixlrs = ({...props}) => {


    return (
        <form noValidate style={{width: '100%'}}>
            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                spacing={2}
            >


                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <IngresoImagenCrop dato={'img'} {...props} ancho={1} alto={1}/>
                </Grid>


                <Grid container size={12}>
                    <IngresoTexto Icono={TitleOutlined} nombre={'Nombre del Mixlr'} dato={'nombre'} {...props}
                    />
                </Grid>

                <Grid container size={12}>
                    <IngresoTexto Icono={GroupOutlined} nombre={'Participante'} dato={'participante'} {...props}
                    />
                </Grid>

                <Grid container size={12}>
                    <IngresoTexto Icono={Link} nombre={'Link'} dato={'link'} {...props}
                    />
                </Grid>

                <Grid container size={6}>
                    <IngresoFecha nombre={'Fecha'} dato={'fecha'} {...props}
                    />
                </Grid>

                <Grid container size={6}>
                    <IngresoHoraSelect nombre={'Hora'} dato={'hora'} {...props}
                    />
                </Grid>


            </Grid>

        </form>

    )

}
export default Formulario_Mixlrs